"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Page error:", error);
  }, [error]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
      <h1 className="text-2xl font-bold text-gray-700 mb-4">
        Something went wrong
      </h1>
      <p className="text-gray-500 mb-6">
        We encountered an unexpected error. Please try again.
      </p>
      <button
        onClick={reset}
        className="px-6 py-2 bg-primary text-white rounded-lg"
      >
        Try again
      </button>
    </div>
  );
}
